import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { ConversationService } from '../services/conversation.service';
import { Router } from '@angular/router';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
import { InputService } from '../services/input.service';
var InputbarComponent = /** @class */ (function () {
    function InputbarComponent(conversationService, router, speechRecognitionService, inputService) {
        this.conversationService = conversationService;
        this.router = router;
        this.speechRecognitionService = speechRecognitionService;
        this.inputService = inputService;
        this.keyword = '';
        this.profileView = false;
        this.isCard = false;
        this.idOutput = new EventEmitter();
        this.isBusy = false;
        this.speechApi = true;
        this.selectedValue = 'Current';
        this.searchGlobal = false;
    }
    Object.defineProperty(InputbarComponent.prototype, "setComponentId", {
        set: function (id) { this.componentId = id; },
        enumerable: true,
        configurable: true
    });
    InputbarComponent.prototype.ngOnInit = function () {
        this.face.nativeElement.focus();
    };
    InputbarComponent.prototype.changeView = function (view) {
        this.selectedValue = view;
    };
    InputbarComponent.prototype.searchByKeyword = function (keyword) {
        var _this = this;
        if (keyword.trim()) {
            this.isBusy = true;
            setTimeout(function () {
                _this.isBusy = false;
            }, 1500);
            this.keyword = keyword;
            this.inputService.changeInputValue(this.componentId, keyword).subscribe(function (result) {
                if (result == "1") {
                    _this.inputService.executeInputWorkflow(_this.componentId).subscribe(function (wfResult) {
                        _this.idOutput.emit(wfResult);
                    });
                }
            });
        }
    };
    InputbarComponent.prototype.searchAll = function (value) {
        var _this = this;
        this.isBusy = true;
        this.conversationService.converse(value).subscribe(function (result) {
            var resultObject = JSON.parse(result);
            _this.isBusy = false;
            if (resultObject.ReturnType == "0") {
                if (resultObject.Arguments) {
                    var path = [];
                    resultObject.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    ;
                    _this.router.navigate(path);
                }
            }
        });
    };
    return InputbarComponent;
}());
export { InputbarComponent };
